export class CreatorRow {
    id!: string
    pristine: boolean = true   // Marks if a record has been edited (allows to showRemove, etc)
    restored: boolean = false  // Marks if a record has been restored from session storage
    enabled?: boolean = true   // Disabled records are not collected for the final processing

    constructor(params: { id: string, pristine?: boolean, restored?: boolean, enabled?: boolean }) {
        Object.assign(this, params)
    }
}